module.exports = __webpack_public_path__ + "static/category-jacket-db5bbe07ab40055f4f81f32a9b04a650.jpg";